import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-Icon',
  templateUrl: './Icon.component.html',
  styleUrls: ['./Icon.component.css']
})
export class IconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
